import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { ComponentBase } from '../../models/ComponentBase';
import { LoginService } from '../../services/login.service';
import {
    UserRight,
    GetCustomerResponse,
} from '../../WebApiClient';
type Customer = GetCustomerResponse;
import { TechnicalHelpModalComponent } from '../technical-help-modal/technical-help-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent extends ComponentBase implements OnInit {
    readonly showOverview: boolean;
    readonly showTimeline: boolean;
    readonly showComponents: boolean;
    readonly showReports: boolean;
    readonly showFiles: boolean;
    readonly showGangs: boolean;
    readonly showMail: boolean;
    readonly showLinks: boolean;
    readonly showEdit: boolean;
    readonly showReportAndStatistics: boolean;
    readonly showTerminalStatement: boolean;
    customer?: Customer | null;
    readonly loginService: LoginService;

    isTerminalStatement: boolean = false;

    constructor(
        loginService: LoginService,
        private readonly modalService: NgbModal,
        private readonly router: Router,
    ) {
        super();

        this.loginService = loginService;
        this.showReports = loginService.hasRights(UserRight.ListProjectTemplates);
        this.showFiles = loginService.hasRights(UserRight.DownloadProjectFilesOnOwnProject);
        this.showGangs = loginService.hasRights(UserRight.ListAllWorkers);
        this.showMail = loginService.hasRights(UserRight.GetMailingList);
        this.showLinks = loginService.hasRights(UserRight.CreateLinkForCustomerProject);
        this.showEdit = loginService.hasRights(UserRight.EditProject);
        this.showReportAndStatistics = loginService.hasRights(UserRight.ListAllProjects);
        this.showOverview = loginService.currentUser !== undefined;
        this.showTimeline = loginService.currentUser !== undefined;
        this.showComponents = loginService.currentUser !== undefined;

        this.showTerminalStatement = loginService.currentUser !== undefined;
    }
    async ngOnInit() {
        let checkRegexp = /terminalstatement/gi;
        this.isTerminalStatement = checkRegexp.test(this.router.url);
        this.loginService.currentCustomer$.subscribe(c => {
            this.customer = c;
        });
        await this.loginService.init();
    }

    public async openSupport() {
        let modal = TechnicalHelpModalComponent.open(this.modalService);

        try {

        }
        catch (e) {
            //user cancelled
        }
    }


    @Input()
    projectId?: string;
    @Input()
    header?: TemplateRef<any>;
    @Input()
    showNavigation: boolean = false;
}
